// extracted by mini-css-extract-plugin
export default {"none":"Spacer_none__VHXe1","small":"Spacer_small__gva3E","middle":"Spacer_middle__75Qns","large":"Spacer_large__6d77Y","border":"Spacer_border__xsTbH"};